import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { APP_NAME } from '@/utils/constants'

const Root = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  background: 'var(--ds-night-canvas, #0e0d12)',
  display: 'flex',
  alignItems: 'flex-end',
})

const Collage = styled(Box)({
  position: 'absolute',
  inset: '-6%',
  zIndex: 1,
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 14,
  transform: 'rotate(-5deg)',
  opacity: 0.5,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 12,
    aspectRatio: '3 / 4',
  },
})

const Glow = styled(Box)({
  position: 'absolute',
  inset: 0,
  zIndex: 2,
  background: [
    'radial-gradient(ellipse 70% 50% at 30% 20%, rgba(190,157,253,0.16), transparent 60%)',
    'radial-gradient(ellipse 60% 50% at 80% 90%, rgba(255,207,125,0.12), transparent 60%)',
  ].join(', '),
})

const QuoteBlock = styled(Box)({
  position: 'relative',
  zIndex: 3,
  padding: 54,
  color: 'var(--ds-night-ink, #f4f3f6)',
})

const Quote = styled(Box)({
  fontSize: 22,
  fontWeight: 650,
  letterSpacing: '-0.025em',
  lineHeight: 1.35,
  maxWidth: 420,
})

const Highlight = styled('span')({
  background: 'var(--ds-gradient-spectrum, currentColor)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
})

const Who = styled(Box)({
  marginTop: 18,
  fontSize: 13,
  color: 'var(--ds-night-ink-muted, rgba(244,243,246,0.6))',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
})

const WhoAvatar = styled(Box)({
  width: 30,
  height: 30,
  borderRadius: '50%',
  background: 'var(--ds-gradient-spectrum, var(--ds-ink))',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 11,
  fontWeight: 800,
  color: '#fff',
  flexShrink: 0,
})

const COLLAGE = [
  '/marketing/landing-v2/a01-wedding.jpg',
  '/marketing/landing-v2/a05-birthday.jpg',
  '/marketing/landing-v2/a02-beach.jpg',
  '/marketing/landing-v2/a06-baby.jpg',
  '/marketing/landing-v2/a07-city.jpg',
  '/marketing/landing-v2/a03-mountains.jpg',
  '/marketing/landing-v2/a04-dog.jpg',
  '/marketing/landing-v2/a08-coffee.jpg',
  '/marketing/landing-v2/a01-wedding.jpg',
]

/**
 * Living-album aside for the sign in / sign up dialog — rotated photo collage
 * plus an evergreen quote. Intentionally not personalized (no "your albums
 * had N visitors" style copy) since there's no backend feed to back it —
 * unlike the mockup, which invents specific names/events for a demo.
 */
export default function AuthAside() {
  return (
    <Root>
      <Collage aria-hidden>
        {COLLAGE.map((src, i) => (
          <img key={i} src={src} alt='' />
        ))}
      </Collage>
      <Glow aria-hidden />
      <QuoteBlock>
        <Quote>
          “The photos everyone means to look at again{' '}
          <Highlight>— until they land somewhere worth returning to.</Highlight>”
        </Quote>
        <Who>
          <WhoAvatar>E</WhoAvatar>
          {APP_NAME} — albums that get revisited, not just uploaded.
        </Who>
      </QuoteBlock>
    </Root>
  )
}
